import { Icon } from '@design-system';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { UrlObject } from 'url';

type Props = {
  label: string;
  href?: string | UrlObject;
  onClick?: (event?: React.MouseEvent<HTMLAnchorElement>) => void;
};

const Breadcrumbs: React.FC<Props> = ({ href, label, onClick }) => {
  const router = useRouter();

  return (
    <div className="w-full border-b border-divider/20 bg-white">
      <div className="wrapper-website flex items-center justify-between py-4 md:py-4">
        {href ? (
          <Link
            className="link flex items-center gap-1"
            href={href}
            onClick={onClick}
            prefetch={false}
          >
            <Icon name="ic_chevron_left" />
            <span>{label}</span>
          </Link>
        ) : (
          <button
            className="link flex items-center gap-1"
            onClick={() => {
              router.back();
              onClick?.();
            }}
            type="button"
          >
            <Icon name="ic_chevron_left" />
            <span>{label}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Breadcrumbs;
